import user from 'btm-user-manager'; //eslint-disable-line import/no-extraneous-dependencies

const emptyMappedData = {
    categoryCodes: [],
    entitlements: []
};

function _containsElement(elementToLookup, allElementsArray) {
    return allElementsArray.indexOf(elementToLookup) !== -1;
}

function filterToActiveSubscriptions(subs) {
    if (!Array.isArray(subs)) {
        console.error('Subscription data is not a valid array', subs);
        return [];
    }

    return subs.filter((sub) => sub.isActive);
}

function getActiveSubscriptions(swid) {
    return user.subscription.getSubscriptions().then((subs) => {
        user.subscription.setSubscriptionsInLocalStorage(subs, swid);
        const filtered = filterToActiveSubscriptions(subs);
        return filtered;
    });
}

function mapSubscriptionData(subscriptions) {
    const mappedSubs = {};

    if (!(subscriptions && subscriptions.length)) {
        return { ...emptyMappedData };
    }

    // Several browsers don't yet support array method "flat()"
    const flatten = (a, b) => {
        return a.concat(b);
    };

    const extractAndFlatten = (func) => {
        return [].concat.apply([], subscriptions.map((sub) => { //eslint-disable-line prefer-spread
            return sub.products.map(func);
        })).reduce(flatten);
    };

    mappedSubs.entitlements = extractAndFlatten((product) => {
        return product.entitlements.map((entitlement) => {
            return entitlement.name;
        });
    });

    mappedSubs.categoryCodes = extractAndFlatten((product) => {
        return product.categoryCodes;
    });

    return mappedSubs;
}


export {
    getActiveSubscriptions,
    filterToActiveSubscriptions,
    mapSubscriptionData,
    _containsElement
};
